import { useGameStore } from '../state/gameStore';

export function TouchControls() {
  const setMovement = useGameStore((state) => state.setMovement);
  const queueAttack = useGameStore((state) => state.queueAttack);
  const press = (x: number, z: number) => () => setMovement({ x, z });
  const release = () => setMovement({ x: 0, z: 0 });

  return (
    <div className="touch-controls" aria-label="Movement controls">
      <button
        aria-label="Move forward"
        onPointerDown={press(0, -1)}
        onPointerUp={release}
        onPointerCancel={release}
      >
        ↑
      </button>
      <button
        aria-label="Move left"
        onPointerDown={press(-1, 0)}
        onPointerUp={release}
        onPointerCancel={release}
      >
        ←
      </button>
      <button
        aria-label="Move backward"
        onPointerDown={press(0, 1)}
        onPointerUp={release}
        onPointerCancel={release}
      >
        ↓
      </button>
      <button
        aria-label="Move right"
        onPointerDown={press(1, 0)}
        onPointerUp={release}
        onPointerCancel={release}
      >
        →
      </button>
      <button className="attack-button" aria-label="Use signature attack" onPointerDown={queueAttack}>
        FUK!
      </button>
    </div>
  );
}
